/**
 * Cabinet-side half of the bridge. The shell creates one host per game
 * launch, pointed at the iframe it just mounted. Messages are trusted
 * only when they come from that iframe's contentWindow.
 */
import { BRIDGE_VERSION, isBridgeMessage, } from './protocol.js';
export function createCartridgeHost(iframe, handlers = {}) {
    const post = (msg) => {
        iframe.contentWindow?.postMessage(msg, '*');
    };
    const onMessage = (event) => {
        if (event.source !== iframe.contentWindow)
            return;
        const data = event.data;
        if (!isBridgeMessage(data))
            return;
        const msg = data;
        switch (msg.type) {
            case 'ready':
                handlers.onReady?.(msg.gameId);
                break;
            case 'started':
                handlers.onStarted?.();
                break;
            case 'score':
                handlers.onScore?.(msg.score);
                break;
            case 'gameover':
                handlers.onGameOver?.({
                    score: msg.score,
                    won: msg.won ?? false,
                    ...(msg.stats !== undefined ? { stats: msg.stats } : {}),
                });
                break;
            case 'exit':
                handlers.onExit?.({
                    ...(msg.score !== undefined ? { score: msg.score } : {}),
                    ...(msg.stats !== undefined ? { stats: msg.stats } : {}),
                });
                break;
            case 'muted':
                handlers.onMuted?.(msg.muted);
                break;
            default:
                break;
        }
    };
    window.addEventListener('message', onMessage);
    return {
        init(opts) {
            post({
                arcadia: BRIDGE_VERSION,
                type: 'init',
                muted: opts.muted,
                ...(opts.seed !== undefined ? { seed: opts.seed } : {}),
            });
        },
        pause() {
            post({ arcadia: BRIDGE_VERSION, type: 'pause' });
        },
        resume() {
            post({ arcadia: BRIDGE_VERSION, type: 'resume' });
        },
        setMuted(muted) {
            post({ arcadia: BRIDGE_VERSION, type: 'mute', muted });
        },
        dispose() {
            window.removeEventListener('message', onMessage);
        },
    };
}
//# sourceMappingURL=cabinet.js.map